import Phaser from 'phaser';
import { GAME_CONFIG } from './game/GameConfig';
window.addEventListener('load',()=>new Phaser.Game(GAME_CONFIG));
